import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, Image, VisuallyHidden} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import quickbooksLogo from '../../../../../../../assets/images/quickbooks-logo.svg'
import myobLogo from '../../../../../../../assets/images/myob-logo.svg'
import xeroLogo from '../../../../../../../assets/images/xero-logo.svg'
import {RadioCard, RadioCardGroup} from '../../../../../components'

const AccountIntegrationSelector = ({
  goToNextPage,
  setAccountingProvider,
  accountingProvider,
  signupProduct,
}) => {
  const {t} = useTranslation('onboarding')

  const selectAccountingProvider = (event) => {
    setAccountingProvider(event.target.value)
    goToNextPage()
  }

  const pointsOnPaymentsSignup = signupProduct === 'points_on_payments'

  return (
    <>
      <Text
        color="mld.neutral.900"
        fontSize="48px"
        letterSpacing="-0.5"
        lineHeight="1"
        fontWeight="400"
        mb="md"
      >
        {t('onboarding:AccountIntegrationSelector.heading')}
      </Text>

      {pointsOnPaymentsSignup && (
        <Text textStyle="body-intro" my="sm">
          {t('onboarding:AccountIntegrationSelector.pointsOnPaymentsWelcome')}
        </Text>
      )}

      <Text textStyle="body-intro" my="sm">
        {t('onboarding:AccountIntegrationSelector.body', {
          context: pointsOnPaymentsSignup ? 'PointsOnPayments' : null,
        })}
      </Text>

      <Box mb="xs" width={{base: 'full', lg: 'fit-content'}}>
        <RadioCardGroup
          value={accountingProvider}
          onChange={selectAccountingProvider}
          columns={[1, 2]}
        >
          <RadioCard
            value="Xero"
            opacity={
              accountingProvider && accountingProvider !== 'Xero' ? 0.5 : 1
            }
            width={{base: 'auto', lg: '224px'}}
            checkedBorderColor="mld.neutral.900"
            checkedBorderWidth="2px"
            checkedBackgroundColor="white"
            focusShadow="0 0 0 3px #F75E15"
            height="120px"
            borderRadius="0"
          >
            <Image src={xeroLogo} width="80px" alt="xero" />
            <VisuallyHidden>Xero</VisuallyHidden>
          </RadioCard>

          <RadioCard
            value="MYOB"
            opacity={
              accountingProvider && accountingProvider !== 'MYOB' ? 0.5 : 1
            }
            width={{base: 'auto', lg: '224px'}}
            checkedBorderColor="mld.neutral.900"
            checkedBorderWidth="2px"
            checkedBackgroundColor="white"
            focusShadow="0 0 0 3px #F75E15"
            height="120px"
            borderRadius="0"
          >
            <Image src={myobLogo} width="106px" alt="MYOB" />
            <VisuallyHidden>MYOB</VisuallyHidden>
          </RadioCard>

          <RadioCard
            value="Quickbooks"
            opacity={
              accountingProvider && accountingProvider !== 'Quickbooks'
                ? 0.5
                : 1
            }
            width={{base: 'auto', lg: '224px'}}
            checkedBorderColor="mld.neutral.900"
            checkedBorderWidth="2px"
            checkedBackgroundColor="white"
            focusShadow="0 0 0 3px #F75E15"
            height="120px"
            borderRadius="0"
          >
            <Image
              src={quickbooksLogo}
              alt="quickbooks"
              width="174px"
              height="48px"
            />
            <VisuallyHidden>Quickbooks</VisuallyHidden>
          </RadioCard>
        </RadioCardGroup>
      </Box>
      <Text textStyle="body-detail">
        {t('onboarding:AccountIntegrationSelector.otherCaption')}
      </Text>
    </>
  )
}

AccountIntegrationSelector.defaultProps = {
  accountingProvider: '',
  goToNextPage: () => {},
  setAccountingProvider: () => {},
}

AccountIntegrationSelector.propTypes = {
  accountingProvider: PropTypes.string,
  goToNextPage: PropTypes.func,
  setAccountingProvider: PropTypes.func,
  signupProduct: PropTypes.oneOf(['points_on_payments', 'payments_on_demand'])
    .isRequired,
}

export default AccountIntegrationSelector
